import React, { useState, useCallback, useContext } from 'react'
import PropTypes from 'prop-types'
import { Form, Field } from 'simple-react-form'
import styles from './styles.css'
import { formValidation, pepOptions } from './formData'
import Button from '@orionx-dev/orionsoft-parts/lib/components/Button'
import KycRadioRectangle from 'App/components/fields/KycRadioRectangle'
import Modal from 'App/components/Modal'
import setGraphQLErrors from '@orionx-dev/orionsoft-parts/lib/helpers/setGraphQLErrors'
import { KycContext } from 'App/KYC/Layout'
import useMessage from 'App/hooks/useMessage'
import { useNavigate } from 'react-router-dom'

const PEP = ({ callNextStep, callBackStep }) => {
  const { kyc, updateKyc } = useContext(KycContext)
  const showMessage = useMessage()
  const navigate = useNavigate()

  const [form, setForm] = useState({ isPep: 0 })
  const [isFormValid, setIsFormValid] = useState(false)
  const [dataWasModified, setDataWasModified] = useState(false)
  const [toggleModal, setToggleModal] = useState(false)

  const isFormValidCheck = values => {
    return formValidation.every(field => field.isValid(values[field.fieldName]))
  }

  const handleFormChange = val => {
    setForm(val)
    setIsFormValid(isFormValidCheck(val))
    setDataWasModified(true)
  }

  const save = useCallback(async () => {
    try {
      if (dataWasModified && !isFormValid) {
        showMessage('Valor incorrecto en formulario')
        return
      }
      const data = await updateKyc(kyc.id, {
        ...kyc.missingInfo,
        isPep: form.isPep !== 2,
      })

      const complianceType = data.updateKyc.kyc.complianceType
      const navigateRoute = complianceType === 'ManualVerification' ? '/' : '../finish'
      navigate(navigateRoute)
    } catch (error) {
      console.error(error)
      setGraphQLErrors(error)
    }
  }, [dataWasModified, isFormValid, form, callNextStep])

  return (
    <Form className={styles.form} state={form} onChange={handleFormChange}>
      <div>
        <div className={styles.sectionTitle}>
          <h1>¿Eres una Persona Expuesta Políticamente?</h1>
          <div className={styles.assistChip} onClick={() => setToggleModal(true)}>
            <span className={styles.assistChipIcon}></span> Conocer más
          </div>
        </div>
        <div className={styles.options}>
          <Field fieldName="isPep" type={KycRadioRectangle} options={pepOptions} />
        </div>
        <div className={styles.submit}>
          <Button onClick={callBackStep} className={styles.buttonOutline}>
            Atrás
          </Button>
          <Button onClick={save} className={styles.buttonPrimary} disabled={!isFormValid}>
            Siguiente
          </Button>
        </div>
      </div>
      <Modal isOpen={toggleModal}>
        <div className={styles.pepModal}>
          <span className={styles.modalCloseIcon} onClick={() => setToggleModal(false)}></span>
          <h1>Personas Expuestas Políticamente</h1>
          <p>
            Según la{' '}
            <a href="https://www.uaf.cl/legislacion/politica.aspx" target="_blank" rel="noreferrer">
              Circular Nº49
            </a>{' '}
            de la Unidad de Análisis Financiero, son PEPs quienes tuvieron o tienen actualmente
            cargos públicos destacados en un país, con hasta al menos 1 año de finalizado el cargo.
          </p>
          <p>Califican como PEPs:</p>
          <ul>
            <li>Presidente de la República.</li>
            <li>Senadores, Diputados y Alcaldes.</li>
            <li>Miembros de las directivas de partidos políticos.</li>
            <li>Ministros del Tribunal Constitucional, Corte Suprema y Cortes de Apelaciones.</li>
            <li>Ministros de Estado, Subsecretarios, Intendentes, Gobernadores, etc.</li>
            <li>
              Comandantes en Jefe de las Fuerzas Armadas, Directores y ejecutivos principales de
              empresas públicas.
            </li>
          </ul>
          <p>
            Esta lista también incluye a familiares cercanos y personas con pactos de actuación
            conjunta.
          </p>
          <p>
            Si necesitas ayuda,{' '}
            <a href="https://support.orionx.com/es/" target="_blank" rel="noreferrer">
              escríbenos
            </a>
            .
          </p>
        </div>
      </Modal>
    </Form>
  )
}

PEP.propTypes = {
  callNextStep: PropTypes.func,
  callBackStep: PropTypes.func,
}

export default PEP
